import React from "react";

/**
 * Render `**bold**` spans in a plain string, and nothing else.
 *
 * The sign-in card names the button the reader has to press, and it has to stand out from the
 * sentence around it or it is just more prose. The text arrives from Cortex as a plain string
 * into a Typography, which React renders as a text node -- so `**Open in browser**` would reach
 * the technician with its asterisks showing.
 *
 * Deliberately not a Markdown renderer. This text is written by us, in one table, and the only
 * thing it needs is emphasis; a full parser here would be a much larger surface, applied to
 * strings that also carry values read off a third party's page.
 *
 * An unbalanced `**` is left exactly as written rather than guessed at: a visible stray marker
 * in one sentence is better than silently swallowing half of it.
 */
export function withEmphasis(text: string): React.ReactNode {
  if (!text || !text.includes("**")) return text;

  const parts = text.split("**");
  // An even number of markers leaves an odd number of parts. Anything else is unbalanced.
  if (parts.length % 2 === 0) return text;

  return parts.map((part, index) =>
    index % 2 === 1 ? <strong key={index}>{part}</strong> : <React.Fragment key={index}>{part}</React.Fragment>
  );
}
